export const onboard = {
  name: 'Your nickname',
  email: 'E-mail',
  password: 'Password',
  passwordRepeat: 'Repeat password',
  forgot: 'Forgot password?',
  login: 'Log in',
  invalidTwoFactorCode: 'Invalid two-factor authentication code',
  staleMfaChallenge: 'Session expired. Please log in again.',
  signInWith: 'Sign in with {{social}}',
  signUpWith: 'Sign up with {{social}}',
  socials: {
    google: 'Google',
    facebook: 'Facebook',
    discord: 'Discord',
  },
  or: 'or',
  noAccount: 'Don’t have an account?',
  createNew: 'Create new',
  back: 'Back to Log in',
  emailVerified: 'Email verified',
  logIn: {
    title: 'Log in',
  },
  restore: {
    title: 'Forgot your password?',
    subTitle: "No worries, we'll send you a link\n to recover your password.",
    send: 'Send',
    sendAgain: 'Send again ',
    success:
      'A password recovery code has been sent to your email address. Please check your inbox and enter the code to proceed',
  },
  register: {
    title: 'Sign in',
    create: 'Register',
    hasAccount: 'Already have an account?',
    emailAlreadyUsed: 'This email address is already registered',
    bySign: 'Agree with',
    policy: 'Terms of Use',
  },
  activation: {
    title: 'Confirm email address',
    subTitle: 'We have sent verification link to your email.',
    newSent: 'Activation link has been sent',
    submit: 'Resend link',
    resend: 'Resend link',
    in: 'in',
  },
  change: {
    success: 'Password has been successfully changed',
    title: 'Create new password',
    subTitle: 'This password should be different\n from the previous password.',
    submit: 'Reset password',
    new: 'New password',
    confirm: 'Confirm password',
  },
};
